webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0MHA":
/***/ (function(module, exports) {

module.exports = {"suggestions":["بدي دوب قلي قلي بجنون بحبك انا مجنون ما بنسى حبك يوم","دنيي برا مجنوني تلج مكوم ما بيزيح، صرتي عندي مسجوني","جرح القلب من فرقاك خزن. ماحد مثلي بمحبوبه تمحن.","يا الجذاب من عينك اباوع حبك البيها، ادري بقلبك هواية سوالف بس تخبيها","مال الهوى و مالي شكون اللي جابني ليك  ما كنت انايا ف حالي بلاو قلبي يانا بيك","بغيتو ولا كرهتو، أنا مكملة في طريقي.","على قد الشوق اللى فى عيوني يا جميل سلم انا ياما عيوني عليك سألوني و ياما بتألم","وماكنتش اعرف قبل النهارده ان العيون دي تعرف تخون بالشكل ده","توك تقول اليوم هذا حصـل خير توك تذكر يوم هانتك الاقـدار ماقلت لى تقدر تحدى المقادير وراك غيرت التحدي بالاعذار","وش مسوي مع غيري وش الدنيا في قربه قول يا روحي انت متهني و إلا بشوقك لي مشغول"]}

/***/ }),

/***/ "9lD/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EYnv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GpNR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JD12":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/font-awesome/css/font-awesome.min.css
var font_awesome_min = __webpack_require__("e0XP");
var font_awesome_min_default = /*#__PURE__*/__webpack_require__.n(font_awesome_min);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-resource/dist/vue-resource.esm.js
var vue_resource_esm = __webpack_require__("8+8L");

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var App = ({
  name: 'app'
});

// Navbar functionality
document.addEventListener('DOMContentLoaded', function () {
  var $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);
  if ($navbarBurgers.length > 0) {
    $navbarBurgers.forEach(function ($el) {
      $el.addEventListener('click', function () {
        var target = $el.dataset.target;
        var $target = document.getElementById(target);
        $el.classList.toggle('is-active');
        $target.classList.toggle('is-active');
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a979b414","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"level"},[_c('div',{staticClass:"level-item"},[_c('a',{attrs:{"href":"https://www.qatar.cmu.edu/","target":"_blank"}},[_c('img',{staticClass:"footer-logo footer-logo-cmuq",attrs:{"src":"/static/cmuq.png"}})])]),_vm._v(" "),_c('div',{staticClass:"level-item"},[_c('a',{attrs:{"href":"https://nyuad.nyu.edu/en/research/centers-labs-and-projects/computational-approaches-to-modeling-language-lab.html","target":"_blank"}},[_c('img',{staticClass:"footer-logo footer-logo-camel",attrs:{"src":"/static/camel.png"}})])]),_vm._v(" "),_c('div',{staticClass:"level-item"},[_c('a',{attrs:{"href":"https://nyuad.nyu.edu","target":"_blank"}},[_c('img',{staticClass:"footer-logo",attrs:{"src":"/static/nyuad.png"}})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("GpNR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Main.vue
var Main = __webpack_require__("Uhku");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-440807d9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main.vue
var Main_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_vm._v("ADIDA: Automatic Dialect Identification for Arabic")]),_vm._v(" "),_c('div',{attrs:{"id":"analyzer-input"}},[_vm._m(0),_vm._v(" "),_c('form',{on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.getID.apply(null, arguments)}}},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-full"},[_c('label',{staticClass:"label"},[_vm._v("Input")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputText),expression:"inputText"}],staticClass:"input ar-input",attrs:{"dir":"rtl","lang":"ar","type":"text","placeholder":"Write a word or sentence to identify"},domProps:{"value":(_vm.inputText)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();},"input":function($event){if($event.target.composing){ return; }_vm.inputText=$event.target.value}}}),_vm._v(" "),(_vm.showInputError)?_c('p',{staticClass:"has-text-danger"},[_vm._v("Error: Invalid input. Please make sure you enter Arabic text.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-one-fifth is-flex"},[_c('a',{staticClass:"button is-primary is-fullwidth align-bottom",on:{"click":_vm.getID}},[_vm._v("Identify")])])])])]),_vm._v(" "),_c('div',{class:{ closed: !_vm.showOutput},attrs:{"id":"id-output"}},[_c('hr'),_vm._v(" "),_c('label',{staticClass:"label"},[_vm._v("Output")]),_vm._v(" "),_c('div',[_vm._l((_vm.scoreData),function(entry,index){return (index < 5)?_c('div',{staticClass:"id-score"},[_c('b',[_vm._v(_vm._s(entry.dialect)+":")]),_vm._v(" "+_vm._s((entry.score * 100).toFixed(1))+"%")]):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"id-score"},[_c('b',[_vm._v("Other:")]),_vm._v(" "+_vm._s((_vm.otherScore * 100).toFixed(1))+" %")]),_vm._v(" "),_c('div',{staticClass:"id-score"},[_c('b',[_vm._v("MSA:")]),_vm._v(" "+_vm._s((_vm.msaScore * 100).toFixed(1))+" %")])],2),_vm._v(" "),_vm._m(1)])])}
var Main_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification is-primary"},[_c('p',[_vm._v("\n        This interface is a demo of the "),_c('a',{attrs:{"href":"https://camel.abudhabi.nyu.edu/madar/","target":"_blank"}},[_vm._v("MADAR project")]),_vm._v("\n        dialect identification system developed by "),_c('a',{attrs:{"href":"http://www.aclweb.org/anthology/C18-1113","target":"_blank"}},[_vm._v("Salameh, Bouamor and Habash (2018)")]),_vm._v(".\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        The system is able to distinguish amongst 25 cities (from Rabat to Muscat) in addition to Modern Standard Arabic.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        To use the demo enter text in Standard or Dialectal Arabic. The cities and regions that our system identifies will be lit up.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        The ADIDA web interface is described in the paper by "),_c('a',{attrs:{"href":"https://www.aclweb.org/anthology/N19-4002","target":"_blank"}},[_vm._v("Obeid, Salameh, Bouamor and Habash (2019)")]),_vm._v(".\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box id-wrapper"},[_c('div',{attrs:{"id":"mapid"}})])}]
var Main_esExports = { render: Main_render, staticRenderFns: Main_staticRenderFns }
/* harmony default export */ var components_Main = (Main_esExports);
// CONCATENATED MODULE: ./src/components/Main.vue
function Main_injectStyle (ssrContext) {
  __webpack_require__("9lD/")
}
var Main_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Main___vue_template_functional__ = false
/* styles */
var Main___vue_styles__ = Main_injectStyle
/* scopeId */
var Main___vue_scopeId__ = "data-v-440807d9"
/* moduleIdentifier (server only) */
var Main___vue_module_identifier__ = null
var Main_Component = Main_normalizeComponent(
  Main["a" /* default */],
  components_Main,
  Main___vue_template_functional__,
  Main___vue_styles__,
  Main___vue_scopeId__,
  Main___vue_module_identifier__
)

/* harmony default export */ var src_components_Main = (Main_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js




vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

var router = new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Main',
    component: src_components_Main
  }]
});

/* harmony default export */ var src_router = (router);
// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__webpack_require__("JD12");

Object.defineProperty(vue_esm["a" /* default */].prototype, '$lodash', { value: lodash_default.a });

vue_esm["a" /* default */].config.productionTip = false;
vue_esm["a" /* default */].use(vue_resource_esm["a" /* default */]);

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: src_router,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "Uhku":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_leaflet_dist_leaflet_css__ = __webpack_require__("EYnv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_leaflet_dist_leaflet_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_leaflet_dist_leaflet_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet__ = __webpack_require__("nrd6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_heatmap_js_plugins_leaflet_heatmap__ = __webpack_require__("KVVV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_heatmap_js_plugins_leaflet_heatmap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_heatmap_js_plugins_leaflet_heatmap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_suggestions_json__ = __webpack_require__("0MHA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_suggestions_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Shared_suggestions_json__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// eslint-disable-next-line
var arRE = /^(['ءآأؤإئابةتثجحخدذرزسشصضطظعغـفقكلمنهوىيًٌٍَُِّْٰٱپچڤگ'0-9٠-٩.،؟؛!@#$٪^&*ـ=+()[\]{}<>?,;:`/\\|"]|\s)+$/;
var whitspaceRE = /\s+/g;
var arCharRE = /[^'ءآأؤإئابةتثجحخدذرزسشصضطظعغـفقكلمنهوىيًٌٍَُِّْٰٱپچڤگ'0-9٠-٩.،؟؛!@#$٪^&*ـ=+()[\]{}<>?,;:`/\\|" ]/g;

var mapCenter = {
  lat: 26.0890995,
  lng: 21.71316185
};

var geolocations = {
  // Uncomment for ADB normilization
  // ABD: { lat: 24.3870789, lng: 54.4185362, name: 'Abu Dhabi' },
  ALE: { lat: 36.2065528, lng: 37.0785453, name: 'Aleppo' },
  ALG: { lat: 36.7538345, lng: 3.0534636, name: 'Algiers' },
  ALX: { lat: 31.2242387, lng: 29.884846, name: 'Alexandria' },
  AMM: { lat: 31.8359753, lng: 35.807547, name: 'Amman' },
  ASW: { lat: 24.0923728, lng: 32.8825966, name: 'Aswan' },
  BAG: { lat: 33.3118099, lng: 44.2858652, name: 'Baghdad' },
  BAS: { lat: 30.5313657, lng: 47.701991, name: 'Basra' },
  BEI: { lat: 33.8892527, lng: 35.4867727, name: 'Beirut' },
  BEN: { lat: 32.0813977, lng: 20.0649607, name: 'Benghazi' },
  CAI: { lat: 30.0595581, lng: 31.2234449, name: 'Cairo' },
  DAM: { lat: 33.5075421, lng: 36.247876, name: 'Damascus' },
  DOH: { lat: 25.2841478, lng: 51.4419567, name: 'Doha' },
  FES: { lat: 34.024029, lng: -5.0367598, name: 'Fez' },
  JED: { lat: 21.4505289, lng: 38.9309624, name: 'Jeddah' },
  JER: { lat: 31.7963272, lng: 35.1108048, name: 'Jerusalem' },
  KHA: { lat: 15.5016995, lng: 32.5025564, name: 'Khartoum' },
  MOS: { lat: 36.353016, lng: 43.07061, name: 'Mosul' },
  MUS: { lat: 23.5841504, lng: 58.3536263, name: 'Muscat' },
  RAB: { lat: 33.9693414, lng: -6.9273026, name: 'Rabat' },
  RIY: { lat: 24.7255553, lng: 46.5423428, name: 'Riyadh' },
  SAL: { lat: 32.0322429, lng: 35.6909932, name: 'Salt' },
  SAN: { lat: 15.3831991, lng: 44.1412405, name: 'Sana\'a' },
  SFX: { lat: 34.7615155, lng: 10.6630587, name: 'Sfax' },
  TRI: { lat: 32.8829717, lng: 13.1708263, name: 'Tripoli' },
  TUN: { lat: 36.7949999, lng: 10.0732378, name: 'Tunis' }
};

var minCircleRadius = 5;
var maxCircleRadius = 50;

var heatMapScale = 100;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Main',
  components: {},
  data: function data() {
    return {
      inputText: __WEBPACK_IMPORTED_MODULE_4__Shared_suggestions_json__["suggestions"][Math.floor(Math.random() * __WEBPACK_IMPORTED_MODULE_4__Shared_suggestions_json__["suggestions"].length)],
      cleanedInputText: '',
      output: null,
      showOutput: false,
      map: null,
      basemapLayer: null,
      heatmapLayer: null,
      circlesLayer: null,
      controlLayer: null,
      scoreData: [],
      msaScore: 0.0,
      otherScore: 0.0,
      showInputError: false,
      showLengthError: false
    };
  },


  methods: {
    validateInput: function validateInput() {
      // return arRE.test(this.inputText);
      this.cleanedInputText = this.inputText.replace(arCharRE, '').replace(whitspaceRE, ' ').trim();
      return this.cleanedInputText.length > 0;
    },
    updateCirclesLayer: function updateCirclesLayer() {
      var dialects = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(geolocations);
      var circles = [];
      var scores = this.output.sentences[0].dialectid;

      for (var i = 0; i < dialects.length; i += 1) {
        var dialect = dialects[i];
        var dialectObj = geolocations[dialect];
        var score = (scores[dialect] * 100).toFixed(1);

        if (parseFloat(score) > 0) {
          var radius = (maxCircleRadius - minCircleRadius) * scores[dialect] + minCircleRadius;
          var latLng = __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.latLng(dialectObj.lat, dialectObj.lng);

          var circle = __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.circleMarker(latLng, {
            radius: radius,
            fill: true,
            fillColor: 'blue',
            fillOpacity: 0.5
          });

          circle.bindPopup('<b>' + dialectObj.name + ':</b> ' + score + '%');

          circles.push(circle);
        }
      }

      this.circlesLayer = __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.layerGroup(circles);
    },
    updateControlLayer: function updateControlLayer() {
      this.controlLayer = __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.control.layers({
        'Point Map': this.circlesLayer,
        'Heat Map': this.heatmapLayer
      }, null);
    },
    getID: function getID() {
      var _this = this;

      this.output = null;
      this.showOutput = false;
      this.showInputError = false;
      this.showLengthError = false;

      if (!this.validateInput()) {
        this.showInputError = true;
        return;
      }

      var splicedInput = this.cleanedInputText.substring(0, 1000);

      this.$http.get('/api' + '/getid/?sent=' + encodeURIComponent(splicedInput)).then(function (response) {
        _this.showOutput = true;
        _this.output = response.body;

        if (_this.map === null) {
          _this.map = __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.map('mapid', {
            minZoom: 3,
            maxZoom: 6,
            center: [mapCenter.lat, mapCenter.lng],
            zoom: 4
          });
          _this.map.scrollWheelZoom.disable();
        }

        _this.basemapLayer = __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.tileLayer('https://api.mapbox.com/styles/v1/{username}/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
          attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
          maxZoom: 18,
          username: 'oo11',
          id: 'ckav6zdze5w511inshyaihqkn',
          accessToken: 'pk.eyJ1Ijoib28xMSIsImEiOiJjams2a3hheW4xdWE4M3hxdWVuM245NDYxIn0.QDW60LMQcW7sllnPWykY7w',
          noWrap: true
        });

        _this.map.addLayer(_this.basemapLayer);

        var heatData = {
          max: heatMapScale,
          data: []
        };

        var dialects = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(geolocations);

        if (response.body.sentences.length > 0) {
          // Uncomment for ABD normilization
          // const norm = 1.0 / (1.0 + response.body.sentences[0].dialectid.DOH);
          var norm = 1.0;

          _this.msaScore = response.body.sentences[0].dialectid.MSA * norm;

          _this.scoreData.splice(0, _this.scoreData.length);
          for (var i = 0; i < dialects.length; i += 1) {
            var dialect = dialects[i];

            if (dialect === 'MSA') {
              // eslint-disable-next-line
              continue;
            }

            // Uncomment for ABD normilization
            // if (dialect === 'ABD') {
            //   // eslint-disable-next-line
            //   continue;
            // }

            var dialectObj = geolocations[dialect];
            var lat = dialectObj.lat;
            var lng = dialectObj.lng;
            var score = response.body.sentences[0].dialectid[dialect] * norm;
            var count = Math.round(heatMapScale * score);

            heatData.data.push({ lat: lat, lng: lng, count: count });
            _this.scoreData.push({ dialect: dialectObj.name, score: score });

            // Uncomment for ABD normilization
            // if (dialect === 'DOH') {
            //   const abdDialectObj = geolocations.ABD;
            //   const abdLat = abdDialectObj.lat;
            //   const abdLng = abdDialectObj.lng;
            //   heatData.data.push({ lat: abdLat, lng: abdLng, count });
            //   this.scoreData.push({ dialect: 'Abu Dhabi', score: score * 1.0000001 });
            // }
          }

          _this.scoreData.sort(function (x, y) {
            return y.score - x.score;
          });

          var otherScore = 0.0;

          for (var _i = 5; _i < _this.scoreData.length; _i += 1) {
            otherScore += _this.scoreData[_i].score;
          }

          _this.otherScore = otherScore;
        }

        if (_this.heatmapLayer === null) {
          var cfg = {
            radius: 80,
            maxOpacity: 0.8,
            scaleRadius: false,
            useLocalExtrema: false,
            latField: 'lat',
            lngField: 'lng',
            valueField: 'count'
          };
          _this.heatmapLayer = new __WEBPACK_IMPORTED_MODULE_3_heatmap_js_plugins_leaflet_heatmap___default.a(cfg);
        } else {
          _this.map.removeLayer(_this.heatmapLayer);
        }

        _this.heatmapLayer.setData(heatData);

        if (_this.circlesLayer !== null) {
          _this.map.removeLayer(_this.circlesLayer);
        }
        _this.updateCirclesLayer();

        if (_this.controlLayer !== null) {
          _this.map.removeControl(_this.controlLayer);
        }
        _this.updateControlLayer();
        _this.map.addControl(_this.controlLayer);

        // Set the default layer
        // this.map.addLayer(this.circlesLayer);
        _this.map.addLayer(_this.circlesLayer);

        _this.map.flyTo([mapCenter.lat, mapCenter.lng], 4);

        $('html, body').animate({
          scrollTop: $('#id-output').offset().top
        }, 1000);
      }, function (response) {
        // Error callback
        // eslint-disable-next-line
        console.log(response.statusText);
      }).catch(function (error) {
        // eslint-disable-next-line
        console.log(error);
      });
    }
  },

  watch: {},

  mounted: function mounted() {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "e0XP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.b95b2c2d3933fbdda256.js